<script>
  import { ShopboxGoLiveApp } from '@shopboxai/sb-go-live-app';
  import { currentUser } from '../stores';
</script>

<ShopboxGoLiveApp user={$currentUser} />
